<
<template>
  <div class="d-inline">
    <img src="/img/load.svg" style="max-height: 20px" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
